export default __webpack_public_path__ + "static/media/cart-03-PT.cf9ca585.jpg";